import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { loadLayout } from '@/utils/dashboardLayout'

Vue.use(Vuetify)

/*
 * App-wide theme. The light palette is unchanged from the original. The dark
 * palette is derived from the dashboard's dark mode (see dashboard-layout.css):
 *   page bg   #0b1019   ->  background
 *   surface   #16202e   ->  surface (cards, sheets, dialogs, navbars)
 *   accent    #2f80ed / #56b6f2 for primary/links
 *   text      #e8eef6 (bright) / #9fb3cc (muted)
 * Flipping $vuetify.theme.dark switches every Vuetify component globally; the
 * initial value mirrors the user's saved dashboard theme so the whole app loads
 * in the right mode. See @/utils/theme for the single source of truth.
 */
export default new Vuetify({
  theme: {
    dark: loadLayout().theme === 'dark',
    options: { customProperties: true }, // expose theme colors as CSS vars (--v-primary-base, ...)
    themes: {
      light: {
        primary: '#0377e8', /* da4949 */
        secondary: '#0377e8', /* da4949 */
        accent: '#737070',
        error: '#ff5252',
        'weldlog-pending-status': '#fef9c3', // Yellow for status 1
        'weldlog-ready-status': '#dbeafe', // Blue for status 2
        'weldlog-finished-status': '#dcfce7' // Green for status 3
      },
      dark: {
        primary: '#2f80ed',
        secondary: '#0377e8',
        accent: '#56b6f2',
        error: '#ff5a5a',
        info: '#56b6f2',
        success: '#4ade80',
        warning: '#fbbf24',
        background: '#0b1019',
        surface: '#16202e',
        // keep weld-log status chips readable on dark surfaces
        'weldlog-pending-status': '#4a3f1a',
        'weldlog-ready-status': '#1e3a5f',
        'weldlog-finished-status': '#1f4a32'
      }
    }
  }
})
